// Vendor Imports
import jQuery from 'jquery';
import * as bootstrap from 'bootstrap'; // import 'bootstrap';



(function ($, bs) {
  console.group('Ontada theme.js');
  console.log('jQuery', $);
  console.log('Bootstrap', bs);
    console.groupEnd();


    // Add toggle grid block component javascript
    const setupToggleGridComponentBlock = () => {
        const $cards = $('.ontada-card');

        const setToggledBlock = (ele) => {
            const $ele = $(ele)
            const textColor = $ele.data("toggled-textcolor")
            const onBgColor = $ele.data("toggled-bgcolor")
            const offBgColor = $ele.data("initial-bgcolor")
            $ele.find(".toggled-text").addClass("show")
            $ele.find(".toggled-text").show();
            $ele.find(".initial-text").hide();
            $ele.addClass(textColor)
            $ele.addClass(onBgColor)
            $ele.removeClass(offBgColor)
        }

        const setUntoggledBlock = (ele) => {
            const $ele = $(ele)
            const textColor = $ele.data("toggled-textcolor")
            const onBgColor = $ele.data("toggled-bgcolor")
            const offBgColor = $ele.data("initial-bgcolor")
            $ele.find(".toggled-text").removeClass("show")
            $ele.find(".toggled-text").hide();
            $ele.find(".initial-text").show();
            $ele.removeClass(textColor)
            $ele.removeClass(onBgColor)
            $ele.addClass(offBgColor)
        }

        $cards.hover(
            function () {
                setToggledBlock(this)
            },
            function () {
                setUntoggledBlock(this)

            }
        )
        // Mobile
        $cards.on('click focus', function () {
            setToggledBlock(this)
        }).on('blur', function () {
            setUntoggledBlock(this)

        })
    }
    setupToggleGridComponentBlock();

    $(document).ready(() => updateComponentHeight())
    $(window).on('resize', () => updateComponentHeight());

    function updateComponentHeight() {

        var spreadHighest = (parent, selector) => {
            var highest = 0;
            var elements = parent.find(selector)
            elements.each(function () {
                var height = $(this).height();
                if (height > highest) {
                    highest = height;
                }
            });
            elements.height(highest);
        };

        var parent = $('.redesigned-content-block');
        spreadHighest(parent, '.segment-layout-column .redesigned-content-block-eyebrow');
        spreadHighest(parent, '.segment-layout-column .title');
    }



    $(document).ready(function () {
        moveLinksIfWide();


        $('.footerwrapper').css('position', 'relative'); 
        positionLowerLinks();

    });

    $(window).resize(function () {
        moveLinksIfWide();


        positionLowerLinks();

    });
    function moveLinksIfWide() {


        if ($(window).width() >= 837) {
            // Move to the last .colLinks
            $('.lower-links').appendTo($('.colLinks').last());
            $('.lower-links').find('a').addClass("CUbtn");
        } else {
            // Move .lower-links back to the top of itself
            $('.lower-links').prependTo('.lower-links');
            $('.lower-links').find('a').removeClass("CUbtn");
        }

    }

    function positionLowerLinks() {

        if ($(window).width() < 837) {
            const $footerWrapper = $('.footerwrapper');
            const $lowerLinks = $('.lower-links');

            // Ensure footerwrapper is relatively positioned
            $footerWrapper.css('position', 'relative');

            // Find the first element under the logo
            const $logoCol = $('.footerimage').closest('.footer--col');
            const $firstUnderLogo = $logoCol.find('.logoDesc, .page-footer__social-icons').first();

            if ($firstUnderLogo.length) {
                const relativeTop = $firstUnderLogo.position().top;

                $lowerLinks.css({
                    position: 'absolute',
                    top: relativeTop + 'px',
                    right: '0px',
                    display: 'block'
                }).appendTo($footerWrapper);
            }
        }

 else {

            $('.lower-links').appendTo($('.colLinks').last());

            // Remove the styles when window is wider
            $('.lower-links').css({
                'position': '',
                'top': '',
                'right': ''
            });

        }
    }



})(jQuery, bootstrap);
//menu - keyboard accessibility
document.addEventListener("DOMContentLoaded", function () {
(function ($) {
    var containerSel = '.listing-filter__main-container';

    // Close on outside click/touch
    $(document).on('mousedown touchstart', function (e) {
        var $container = $(containerSel);
        if (!$container.is(e.target) && $container.has(e.target).length === 0) {
            $container.find('details[open]').removeAttr('open');
        }
    });

    // Close on Escape
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            $(containerSel + ' details[open]').removeAttr('open');
        }
    });

    // Close other filters when one opens (preferred: native 'toggle' on <details>)
    $(document).on('toggle', containerSel + ' details', function () {
        if (this.open) {
            // Close all other open <details> in the same container
            $(this)
                .closest(containerSel)
                .find('details[open]')
                .not(this)
                .removeAttr('open');
        }
    });

    // Fallback for environments where 'toggle' might not fire as expected:
    $(document).on('click', containerSel + ' details > summary', function () {
        var $details = $(this).parent('details');
        // Defer until after browser toggles the 'open' attribute
        setTimeout(function () {
            if ($details.prop('open')) {
                $details
                    .closest(containerSel)
                    .find('details[open]')
                    .not($details)
                    .removeAttr('open');
            }
        }, 0);
    });

  
    })(jQuery);
    //new close subnav/////////////////////

    (function ($) {
        const triggerSel = '.global-nav-main-bar-link[role="button"][data-target]';

      
    })(jQuery);
});
document.addEventListener('DOMContentLoaded', function () {

    const offcanvasEl = document.getElementById('global-nav-mobile-24326');
    const supportsInert = 'inert' in document.createElement('div');
    const mqDesktop = window.matchMedia('(min-width: 992px)');
    function disableOffcanvasFocus() {

        offcanvasEl.setAttribute('aria-hidden', 'true');

        offcanvasEl.setAttribute('tabindex', '-1');

        if (supportsInert) {

            offcanvasEl.setAttribute('inert', '');

        } else {
            offcanvasEl.querySelectorAll('a, button, input, [tabindex]').forEach(el => {
                if (!el.hasAttribute('data-orig-tabindex')) {
                    el.setAttribute('data-orig-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
                }
                el.setAttribute('tabindex', -1);
            });
        }
   }
   function enableOffcanvasFocus() {
        offcanvasEl.setAttribute('aria-hidden', 'false');
        offcanvasEl.removeAttribute('tabindex');
        if (supportsInert) {
            offcanvasEl.removeAttribute('inert');
        }
        else
        {
            offcanvasEl.querySelectorAll('[data-orig-tabindex]').forEach(el => {
                const v = el.getAttribute('data-orig-tabindex');
                if (v === 'none') el.removeAttribute('tabindex');
                else el.setAttribute('tabindex', v);
                el.removeAttribute('data-orig-tabindex');
            });
        }
    }
    offcanvasEl.addEventListener('hidden.bs.offcanvas', disableOffcanvasFocus);

    offcanvasEl.addEventListener('shown.bs.offcanvas', enableOffcanvasFocus);
    // Initial state

    disableOffcanvasFocus();

    function closeOffcanvasIfDesktop(e) {
        if (!e.matches) return; 

        // only if open
        if (!offcanvasEl.classList.contains('show')) return;

        // try dismiss trigger inside offcanvas
        const dismissEl = offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"]');
        if (dismissEl) {
            dismissEl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            return;
        }

        // fallback: Bootstrap API
        if (window.bootstrap?.Offcanvas) {
            const inst =
                window.bootstrap.Offcanvas.getInstance(offcanvasEl) ||
                window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
            inst.hide();
            return;
        }
    }

    // Close if already desktop on load
    closeOffcanvasIfDesktop(mqDesktop);

    // Run on viewport changes
    if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener('change', closeOffcanvasIfDesktop);
    } else {
        // Safari fallback
        mqDesktop.addListener(closeOffcanvasIfDesktop);
    }

    //new

    (function ($) {
        const triggerSel = '.global-nav-main-bar-link[role="button"][data-target]';

        // Helper: get submenu from trigger
        function getSubmenu($trigger) {
            const sel = $trigger.attr('data-target');
            return sel ? $(sel) : $();
        }

        // Open submenu
        function openSubmenu($trigger, $submenu) {
            closeAllExcept($trigger);
            $trigger.attr('aria-expanded', 'true');
            $submenu.removeAttr('hidden');
        }

        // Close submenu
        function closeSubmenu($trigger, $submenu) {
            $trigger.attr('aria-expanded', 'false');
            $submenu.attr('hidden', 'hidden');
        }

        // Close all except one trigger
        function closeAllExcept($exceptTrigger) {
            $(triggerSel).each(function () {
                const $t = $(this);
                if (!$exceptTrigger || $t[0] !== $exceptTrigger[0]) {
                    const $s = getSubmenu($t);
                    $t.attr('aria-expanded', 'false');
                    $s.attr('hidden', 'hidden');
                }
            });
        }

        // === Open on keyboard: Enter, Space, ArrowDown ===
        $(document).on('keydown', triggerSel, function (e) {
            const key = e.key || e.keyCode;
            const activateKeys = ['Enter', ' ', 'Spacebar', 'ArrowDown'];
            const activateCodes = [13, 32, 40];

            if (activateKeys.includes(key) || activateCodes.includes(key)) {
                e.preventDefault();
                const $trigger = $(this);
                const $submenu = getSubmenu($trigger);
                openSubmenu($trigger, $submenu);
                focusFirstIn($submenu, $trigger);
            }
        });

        // === Toggle on click ===
        $(document).on('click', triggerSel, function (e) {
            e.preventDefault();
            const $trigger = $(this);
            const $submenu = getSubmenu($trigger);
            const isExpanded = $trigger.attr('aria-expanded') === 'true';

            if (isExpanded) {
                closeSubmenu($trigger, $submenu);
            } else {
                openSubmenu($trigger, $submenu);
            }
        });

        // === Close on Escape inside submenu ===
        $(document).on('keydown', '[id^="sub-nav-target-"]', function (e) {
            const key = e.key || e.keyCode;
            if (key === 'Escape' || key === 27) {
                e.preventDefault();
                const $submenu = $(this);
                const $trigger = $('a.global-nav-main-bar-link[role="button"][data-target="#' + this.id + '"]');
                closeSubmenu($trigger, $submenu);
                $trigger.focus();
            }
        });

        // === Close when clicking outside ===
        $(document).on('mousedown', function (e) {
            const $openTriggers = $(triggerSel).filter('[aria-expanded="true"]');
            if (!$openTriggers.length) return;

            const clickedInsideAny = $openTriggers.toArray().some(t => {
                const $t = $(t);
                const $s = getSubmenu($t);
                return $t.is(e.target) || $t.has(e.target).length || $s.is(e.target) || $s.has(e.target).length;
            });

            if (!clickedInsideAny) {
                closeAllExcept(null);
            }
        });

        // === Close when focus leaves submenu ===
        $(document).on('focusout', '[id^="sub-nav-target-"]', function () {
            const $submenu = $(this);
            const $trigger = $('a.global-nav-main-bar-link[role="button"][data-target="#' + this.id + '"]');

            setTimeout(function () {
                const active = document.activeElement;
                const focusInsideSubnav = $submenu.find(active).length > 0;
                const focusOnTrigger = $trigger.is(active);

                if (!focusInsideSubnav && !focusOnTrigger) {
                    closeSubmenu($trigger, $submenu);

                    // Optional: move focus to next main nav item
                    const $nextItem = $trigger.closest('li').next('li').find('a.global-nav-main-bar-link');
                    if ($nextItem.length) $nextItem.focus();
                }
            }, 0);
        });

    })(jQuery);

});

document.addEventListener('DOMContentLoaded', function () {
    (function ($) {
        const triggerSel = '.global-nav-main-bar-link[role="button"][data-target]';

        function getSubmenu($trigger) {
            const sel = $trigger.attr('data-target');
            return sel ? $(sel) : $();
        }

        function openSubmenu($trigger, $submenu) {
            closeAllExcept($trigger);
            $trigger.attr('aria-expanded', 'true');
            $submenu.removeAttr('hidden');
        }

        function closeSubmenu($trigger, $submenu) {
            $trigger.attr('aria-expanded', 'false');
            $submenu.attr('hidden', '');
        }

        function closeAllExcept($exceptTrigger) {
            $(triggerSel).each(function () {
                const $t = $(this);
                if (!$exceptTrigger || $t[0] !== $exceptTrigger[0]) {
                    const $s = getSubmenu($t);
                    $t.attr('aria-expanded', 'false');
                    $s.attr('hidden', '');
                }
            });
        }

        function focusFirstIn($submenu, fallbackTrigger) {
            const $first = $submenu
                .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                .filter(':visible')
                .first();
            if ($first.length) $first.focus();
            else if (fallbackTrigger) fallbackTrigger.focus();
        }

        $(document).on('keydown', triggerSel, function (e) {
            const key = e.key || e.keyCode;
            if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 'ArrowDown' || key === 13 || key === 32 || key === 40) {
                e.preventDefault();
                const $trigger = $(this);
                const $submenu = getSubmenu($trigger);
                openSubmenu($trigger, $submenu);
                focusFirstIn($submenu, $trigger);
            }
        });

        $(document).on('click', triggerSel, function (e) {
            e.preventDefault();
            const $trigger = $(this);
            const $submenu = getSubmenu($trigger);
            const isExpanded = $trigger.attr('aria-expanded') === 'true';
            if (isExpanded) {
                closeSubmenu($trigger, $submenu);
            } else {
                openSubmenu($trigger, $submenu);
                // optional: focusFirstIn($submenu, $trigger);
            }
        });

        $(document).on('keydown', '[id^="sub-nav-target-"]', function (e) {
            const key = e.key || e.keyCode;
            if (key === 'Escape' || key === 27) {
                e.preventDefault();
                const $submenu = $(this);
                const $trigger = $('a.global-nav-main-bar-link[role="button"][data-target="#' + this.id + '"]');
                closeSubmenu($trigger, $submenu);
                $trigger.focus();
            }
        });

        $(document).on('mousedown', function (e) {
            const $openTriggers = $(triggerSel).filter('[aria-expanded="true"]');
            if (!$openTriggers.length) return;

            const clickedInsideAny = $openTriggers.toArray().some(t => {
                const $t = $(t);
                const $s = getSubmenu($t);
                return $t.is(e.target) || $t.has(e.target).length || $s.is(e.target) || $s.has(e.target).length;
            });

            if (!clickedInsideAny) {
                closeAllExcept(null);
            }
        });

        // Close subnav when focus leaves it
        $(document).on('focusout', '[id^="sub-nav-target-"]', function () {
            const $submenu = $(this);
            const $trigger = $('a.global-nav-main-bar-link[role="button"][data-target="#' + this.id + '"]');

            setTimeout(function () {
                const active = document.activeElement;
                const focusInsideSubnav = $submenu.find(active).length > 0;
                const focusOnTrigger = $trigger.is(active);

                if (!focusInsideSubnav && !focusOnTrigger) {
                    $submenu.attr('hidden', '');
                    $trigger.attr('aria-expanded', 'false');
                    // (Optional) move focus to next main nav item
                    const $nextItem = $trigger.closest('li').next('li').find('a.global-nav-main-bar-link');
                    if ($nextItem.length) $nextItem.focus();
                }
            }, 0);
        });
    })(jQuery);

    (function ($) {
        const triggerSel = '.global-nav-main-bar-link[role="button"][data-target]';

        // Helper: get submenu from trigger
        function getSubmenu($trigger) {
            const sel = $trigger.attr('data-target');
            return sel ? $(sel) : $();
        }

        // Open submenu
        function openSubmenu($trigger, $submenu) {
            $trigger.attr('aria-expanded', 'true');
            $submenu.removeAttr('hidden'); // or add .is-open class
        }

        // Close submenu
        function closeSubmenu($trigger, $submenu) {
            $trigger.attr('aria-expanded', 'false');
            $submenu.attr('hidden', ''); // or remove .is-open class
        }

        // === Keyboard open on Enter ===
        $(document).on('keydown', triggerSel, function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                const $trigger = $(this);
                const $submenu = getSubmenu($trigger);
                openSubmenu($trigger, $submenu);
                // Move focus to first submenu item
                const $firstItem = $submenu.find('a, button').first();
                if ($firstItem.length) $firstItem.focus();
            }
        });

        // === Close when focus leaves submenu ===
        $(document).on('focusout', '[id^="sub-nav-target-"]', function () {
            const $submenu = $(this);
            const $trigger = $('a[data-target="#' + this.id + '"]');
            setTimeout(function () {
                const active = document.activeElement;
                if (!$submenu.find(active).length && !$trigger.is(active)) {
                    closeSubmenu($trigger, $submenu);
                }
            }, 0);

            // Close submenu and also reset search container
            $(document).on('focusout', '[id^="sub-nav-target-"]', function () {
                var $submenu = $(this);
                var $trigger = $('a.global-nav-main-bar-link[role="button"][data-target="#' + this.id + '"]');

                setTimeout(function () {
                    var active = document.activeElement;
                    var focusInsideSubnav = $submenu[0] && $submenu[0].contains(active);
                    var focusOnTrigger = $trigger.is(active);

                    if (!focusInsideSubnav && !focusOnTrigger) {
                        //  Hide submenu
                        $submenu.attr('hidden', '');
                        $trigger.attr('aria-expanded', 'false');

                        //  Remove 'open' from search container
                        $('.search.input-group.input-group-lg').removeClass('open');

                        // Optional: move focus to next main nav item
                        var $nextItem = $trigger.closest('li').next('li').find('a.global-nav-main-bar-link');
                        if ($nextItem.length) {
                            $nextItem.focus();
                        } else {
                            $trigger.focus();
                        }
                    }
                }, 0);
            });

        });
    })(jQuery);


    // Close search and reveal links when focus leaves the nav bar items container
    $(document).on('focusout.navClose', '.global-nav-main-bar-items', function (e) {
        var container = this;
        var next = e.relatedTarget; // element receiving focus (may be null in some cases)

        // If there is no next focus target OR it's outside the container, apply changes
        if (!next || !container.contains(next)) {
            // Remove 'show' from the search wrapper
            $('.search.input-group.input-group-lg').removeClass('show');
            // Remove 'd-none' from the main bar links
            $('.global-nav-main-bar-links').removeClass('hidelinks');
            // (Optional) keep aria in sync if needed:
            // $('#search-button').attr('aria-expanded', 'false');
        }
    });

    // Safety net: handle blur cases where relatedTarget is null
    $(document).on('blur.navClose', '.global-nav-main-bar-items', function () {
        var container = this;
        setTimeout(function () {
            var active = document.activeElement;
            if (!container.contains(active)) {
                $('.search.input-group.input-group-lg').removeClass('show');
                $('.global-nav-main-bar-links').removeClass('hidelinks');
                // $('#search-button').attr('aria-expanded', 'false');
            }
        }, 0);
    });

    // Optional: also close on click/touch outside the nav container
    $(document).on('mousedown.navClose touchstart.navClose', function (e) {
        if (!$(e.target).closest('.global-nav-main-bar-items').length) {
            $('.search.input-group.input-group-lg').removeClass('show');
            $('.global-nav-main-bar-links').removeClass('hidelinks');
            // $('#search-button').attr('aria-expanded', 'false');
        }
    });

    ///new

    (function () {
        var SEL = {
            container: '.global-nav-main-bar-items',
            button: '#search-button',
            input: '.navbar-search-input',
            searchWrapper: '.search.input-group.input-group-lg',
            links: '.global-nav-main-bar-links' // has 'hidelinks' when links hidden
        };

        // --- Helpers -------------------------------------------------------------

        function setOpeningGuard(isOpening) {
            var $container = $(SEL.container);
            if (!$container.length) return;
            $container.data('searchOpening', !!isOpening);
            if (isOpening) {
                // Auto-clear the opening guard shortly after we open
                setTimeout(function () { $container.data('searchOpening', false); }, 60);
            }
        }

        function isOpeningGuardActive() {
            var $container = $(SEL.container);
            return $container.length && $container.data('searchOpening') === true;
        }

        function openAndFocus() {
            var $button = $(SEL.button);
            var $input = $(SEL.input);
            var $search = $(SEL.searchWrapper);
            var $links = $(SEL.links);

            // Guard: we�re opening�suppress close handlers for a short window
            setOpeningGuard(true);

            // Ensure search shows and (optionally) links hide
            $search.addClass('show');

            $button.attr('aria-expanded', 'true');

            // Defer focus so DOM/class changes settle first
            setTimeout(function () {
                if ($input.length) {
                    $input.trigger('focus');
                    var val = $input.val() || '';
                    if ($input[0] && $input[0].setSelectionRange) {
                        $input[0].setSelectionRange(val.length, val.length);
                    }
                } else {
                    console.warn('[search] input not found for focus');
                }
            }, 20);
        }

        function closeSearchAndRevealLinks() {
            // If we are in the middle of opening, skip closing
            if (isOpeningGuardActive()) return;

            $(SEL.searchWrapper).removeClass('show');
            $(SEL.links).removeClass('hidelinks');
            $(SEL.button).attr('aria-expanded', 'false');
        }

        // --- Handlers ------------------------------------------------------------

        // Activate via click (covers keyboard activation too)
        $(document).on('click.navSearch', SEL.button, function (e) {
            e.preventDefault();
            e.stopPropagation(); // reduce interference from other click handlers
            openAndFocus();
        });

        // Explicitly handle Enter/Space on the button
        $(document).on('keydown.navSearch', SEL.button, function (e) {
            var key = e.key || e.which;
            var isEnter = key === 'Enter' || key === 13;
            var isSpace = key === ' ' || key === 'Spacebar' || key === 32;
            if (isEnter || isSpace) {
                e.preventDefault();
                e.stopPropagation(); // avoid bubbling to competing key handlers
                openAndFocus();
            }
        });

        // Close when tabbing away from the input (Tab or Shift+Tab)
        $(document).on('keydown.navSearch', SEL.input, function (e) {
            var key = e.key || e.which;
            var isTab = key === 'Tab' || key === 9;
            if (isTab) {
                // Don�t preventDefault�let focus move naturally
                closeSearchAndRevealLinks();
            }
        });

        // Optional: keep Escape closing on the input
        $(document).on('keydown.navSearch', SEL.input, function (e) {
            var key = e.key || e.which;
            var isEscape = key === 'Escape' || key === 'Esc' || key === 27;
            if (isEscape) {
                e.preventDefault(); // optional
                closeSearchAndRevealLinks();
                // Optionally return focus to trigger:
                // $(SEL.button).trigger('focus');
            }
        });

        // Close when focus leaves the container (keyboard tab-out or programmatic move)
        $(document).on('focusout.navSearch', SEL.container, function (e) {
            var container = this;
            var next = e.relatedTarget; // may be null
            // Only close if moving outside AND not during opening
            if (!next || !container.contains(next)) {
                closeSearchAndRevealLinks();
            }
        });

        // Safety net for browsers without reliable relatedTarget
        $(document).on('blur.navSearch', SEL.container, function () {
            var container = this;
            setTimeout(function () {
                var active = document.activeElement;
                if (!container.contains(active)) {
                    closeSearchAndRevealLinks();
                }
            }, 0);
        });

        // Optional: close on click/touch outside the container
        $(document).on('mousedown.navSearch touchstart.navSearch', function (e) {
            // If opening guard is active, skip this outside-close
            if (isOpeningGuardActive()) return;
            if (!$(e.target).closest(SEL.container).length) {
                closeSearchAndRevealLinks();
            }
        });
    })();


});

//end - menu - keyboard accessibility